import { URLSearchParams } from '@angular/http';
import { ConvertUtils, ValueModel, PageInfo } from '../../core';

export interface IFilterModel {
	items: FilterItemModel[];
}

export class FilterModel implements IFilterModel {
	items: FilterItemModel[] = [];

	clearAll() {
		let idx, re;
		do {
			idx = this.items.findIndex(x => !x.hidden);
			if (idx >= 0) {
				re = this.items[idx];
				if (re) {
					this.clear(re);
				}
				this.items.splice(idx, 1);
			}
		}
		while (idx >= 0);
	}

	clear(model: FilterItemModel) {
		model.values.length = 0;
		model.range.start = null;
		model.range.end = null;
	}
}

export class FilterItemModel {
	id: string;
	name: string;
	hidden?: boolean;
	values?: ValueModel[];
	range?: FilterItemRangeModel;
}

export interface FilterItemRangeModel {
	start: any;
	end: any;
}

export interface IFilterQueryParams {
	page?: number;
	pageSize?: number;
	sortBy?: string;
	sortDesc?: boolean;
	filter?: FilterModel;
}

export class FilterQueryParams implements IFilterQueryParams {
	page?: number = null;
	pageSize?: number = null;
	sortBy?: string = null;
	sortDesc?: boolean = null;
	filter?: FilterModel = new FilterModel();

	public AsUrlSearchParams(): URLSearchParams {
		return FilterQueryParams.CreateUrlParamsFrom(this);
	}

	public static MapUrlParams(params: URLSearchParams): { [key: string]: string } {
		let result: { [key: string]: string } = {};

		params.paramsMap.forEach((value: string[], key: string) => {
			result[key] = (value && value.length > 0) ? value[0] : '';
		});

		return result;
	}

	public static CreateParamsFrom(filterParams: IFilterQueryParams): { [key: string]: string } {
		let params = FilterQueryParams.CreateUrlParamsFrom(filterParams);
		return FilterQueryParams.MapUrlParams(params);
	}

	public static CreateFromDictionary(params: { [key: string]: string }): FilterQueryParams {
		let result = new FilterQueryParams();

		Object.keys(params).forEach(key => {
			FilterQueryParams.ParseParameterValue(result, key, params[key] || '');
		});

		return result;
	}

	public static CreateFrom(params: URLSearchParams): FilterQueryParams {
		let result = new FilterQueryParams();

		params.paramsMap.forEach((value: string[], key: string) => {
			if (!Array.isArray(value) || value.length < 1) {
				return;
			}

			FilterQueryParams.ParseParameterValue(result, key, value[0].trim());
		});

		return result;
	}

	public static UpdateFilterItem(filter: FilterModel, key: string, value: any) {
		let item = filter.items.find(x => x.id == key);
		if (item == null) {
			item = {
				id: key,
				name: key,
				hidden: true,
				values: []
			};
			filter.items.push(item);
		}

		item.values.length = 0;
		item.values.push({ value: value, name: key });
	}

	private static ParseParameterValue(filter: FilterQueryParams, key: string, value: string) {
		switch (key) {
			case 'page':
				filter.page = ConvertUtils.asNumber(value);
				break;
			case 'pagesize':
				filter.pageSize = ConvertUtils.asNumber(value);
				break;
			case 'sortby':
				filter.sortBy = value;
				break;
			case 'sortdesc':
				filter.sortDesc = ConvertUtils.asBoolean(value);
				break;
			default:
				let filterItem = new FilterItemModel();

				filterItem.id = key;

				if (value.indexOf('--')) { // range
					let range = FilterQueryParams.TryParseRange(value);
					if (range == null) {
						break;
					}

					filterItem.range = range;
				}
				else {
					let range = FilterQueryParams.TryParseList(value);
					if (range == null) {
						break;
					}

					filterItem.values = range;
				}
				break;
		}
	}

	private static TryParseList(value: string): ValueModel[] {
		return ConvertUtils
			.asNumberList(value)
			.map(s => <ValueModel>{ name: s + '', value: s });
	}

	private static TryParseRange(value: string): FilterItemRangeModel {
		let parts = value.split('--');

		if (parts.length == 0) {
			return null;
		}

		return {
			start: ConvertUtils.asDate(parts[0]) || ConvertUtils.asNumber(parts[0]),
			end: ConvertUtils.asDate(parts[1]) || ConvertUtils.asNumber(parts[1])
		};
	}

	public static PageInfoToSearchParams(pageInfo: PageInfo): URLSearchParams {
		let params = new URLSearchParams();

		params.set('page', '' + (pageInfo.page || 1));
		params.set('pagesize', '' + (pageInfo.pageSize || 25));

		return params;
	}

	public static CreateUrlParamsFrom(filterParams: IFilterQueryParams): URLSearchParams {
		let params = new URLSearchParams();

		params.set('page', '' + (filterParams.page || 1));
		params.set('pagesize', '' + (filterParams.pageSize || 25));
		params.set('sortby', '' + (filterParams.sortBy || ''));
		params.set('sortdesc', '' + (filterParams.sortDesc || 'false'));

		if (filterParams.filter != null) {
			filterParams.filter.items.forEach(e => {
				if (e.range && (e.range.start != null || e.range.end != null)) {
					let range = e.range.start != null ? JSON.stringify(e.range.start).replace(/"/g, '') : '';

					range += '--';
					range += (e.range.end != null) ? JSON.stringify(e.range.end).replace(/"/g, '') : '';

					params.set(e.id, range);
				}
				else {
					params.set(e.id, e.values.map(x => x.value).join(','));
				}
			});
		}

		return params;
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/models/filter.models.ts